import { render, staticRenderFns } from "./Cloze.vue?vue&type=template&id=7b22634a&"
import script from "./Cloze.vue?vue&type=script&lang=js&"
export * from "./Cloze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports